import { useState, useEffect } from 'react';
import { FileText } from 'lucide-react';

export function FilePreview({ file, className = '' }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!file) { setUrl(null); return; }
    const u = URL.createObjectURL(file);
    setUrl(u);
    return () => URL.revokeObjectURL(u);
  }, [file]);

  if (!file) return null;

  const type = file.type || '';
  const name = (file.name || '').toLowerCase();
  const isImg = type.startsWith('image/') || /\.(png|jpe?g|gif|webp|bmp|heic|heif)$/.test(name);
  const isPdf = type === 'application/pdf' || name.endsWith('.pdf');

  return (
    <div className={`border border-slate-200 rounded-lg bg-slate-50 overflow-hidden ${className}`} data-testid="file-preview">
      <div className="flex items-center gap-2 px-3 py-1.5 border-b border-slate-200 bg-white text-xs text-slate-600">
        <FileText size={14} className="shrink-0 text-[#1a4b8c]" />
        <span className="truncate font-medium">{file.name}</span>
        <span className="ml-auto shrink-0 text-slate-400">{(file.size / 1024).toFixed(0)} KB</span>
      </div>
      {isImg && url ? (
        <img src={url} alt="anteprima documento" className="max-h-80 w-full object-contain bg-white" />
      ) : isPdf && url ? (
        <iframe title="anteprima documento" src={url} className="w-full h-80 bg-white" />
      ) : (
        <div className="p-6 text-center text-sm text-slate-500">Anteprima non disponibile per questo formato.<br />Il file verrà comunque caricato.</div>
      )}
    </div>
  );
}

export default FilePreview;
